// Afidium
import { Yii } from "libraries/interfaces/Yii";

const LOADER = {
    loadingBookings: Yii.t('wui-sasha-js', 'Récupération des dossiers en cours'),
};

export const WORDING = {
    ...LOADER,
};